/** Company / legal identity for Terms, Privacy Policy, and DPA (build-time env). */

const FALLBACK = {
  legalName: "FractoLabs Pty Ltd",
  brandName: "FractoLabs",
  acn: "[ACN]",
  abn: "[ABN]",
  address: "8 Springdale St, Claremont Meadows, Wollongong, NSW, Australia, 2500",
  supportEmail: "support@fractolabs.com",
  governingLaw: "New South Wales, Australia",
};

export const LEGAL_COMPANY = {
  legalName: process.env.REACT_APP_COMPANY_LEGAL_NAME || FALLBACK.legalName,
  brandName: process.env.REACT_APP_COMPANY_BRAND_NAME || FALLBACK.brandName,
  acn: process.env.REACT_APP_COMPANY_ACN || FALLBACK.acn,
  abn: process.env.REACT_APP_COMPANY_ABN || FALLBACK.abn,
  address: process.env.REACT_APP_COMPANY_ADDRESS || FALLBACK.address,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || FALLBACK.supportEmail,
  governingLaw: process.env.REACT_APP_GOVERNING_LAW || FALLBACK.governingLaw,
};
